import {
  defineComponent,
  ref,
  provide,
  reactive,
  toRefs,
  getCurrentInstance,
  onMounted,
} from 'vue';
import { useRouter } from 'vue-router';
import PageLoading from '@/components/common/PageLoading.vue';
import NewIndexSiteLayout from '@/components/newIndex/NewIndexSiteLayout.vue';
import Footer from '@/components/layout/footer.vue';
import SideComponent from '@/components/common/SideComponent.vue';
import Loading from '@/components/common/Loading.vue';
import bus from 'vue3-eventbus';
import { getWeeklyPickList } from '@/api/common';
import { mapWeeklyPickList } from '@/utils/newIndexMappers';

export default defineComponent({
  components: {
    PageLoading,
    NewIndexSiteLayout,
    Footer,
    SideComponent,
    Loading,
  },
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();

    const data = reactive({
      isLoading: true,
      isListLoading: false,
      list: [],
      page: 1,
      nomore: false,
    });

    const showMenu = ref(proxy.$menus);
    provide('showMenu', showMenu);

    const viewBox = ref(null);

    const scroll = (val) => {
      if (!viewBox.value) return;
      viewBox.value.scrollIntoView({
        behavior: 'smooth',
        block: val === 'top' ? 'start' : 'end',
        inline: 'center',
      });
    };

    const fetchList = async (page = 1) => {
      if (page === 1) {
        data.isListLoading = true;
      }
      try {
        const res = await getWeeklyPickList({ page });
        const { items, pagination } = mapWeeklyPickList(res);
        if (page === 1) {
          data.list = items;
        } else {
          data.list = data.list.concat(items);
        }
        data.page = page;
        const current = pagination?.current_page ?? pagination?.current ?? page;
        const last = pagination?.last_page ?? pagination?.total_page;
        const total = pagination?.total;
        if (last != null) {
          data.nomore = current >= last;
        } else if (total != null) {
          data.nomore = data.list.length >= total;
        } else {
          data.nomore = items.length === 0;
        }
      } catch {
        if (page === 1) {
          data.list = [];
        }
        data.nomore = true;
      } finally {
        data.isListLoading = false;
        data.isLoading = false;
        bus.emit('showFooter', true);
      }
    };

    const loadMore = () => {
      if (data.isListLoading || data.nomore) return;
      fetchList(data.page + 1);
    };

    const toDetail = (item) => {
      if (!item) return;
      const url = item.detailUrl || (item.id ? `/weekly-pick/${item.id}` : '/weekly-pick');
      router.push(url);
    };

    onMounted(() => {
      fetchList(1);
    });

    return {
      ...toRefs(data),
      viewBox,
      scroll,
      loadMore,
      toDetail,
    };
  },
});
